<template>
  <div class="item-headline" v-show="show">
    <div class="item-headline__inner">
      <template v-if="1 <= stateLists.length && currentPage.slug === 'options'">オプションを選択</template>
      <template v-else-if="2 <= stateLists.length && currentPage.slug === 'dolls'">お人形を選択</template>
        <template v-else-if="1 === stateLists.length && currentPage.slug === 'dolls'">お人形({{ stateLists[0].name }})を選択</template>
        <template v-else-if="1 === stateLists.length">{{ stateLists[0].name }}を選択</template>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapState({
      stateLists: state => state.step.lists,
      currentPage: state => state.step.current,
    })
  },
  watch: {
    stateLists: {
      handler(val) {
        this.dataSet()
      },
      deep: true
    },
  },
  created() {
    this.dataSet()
  },
  methods: {
    dataSet() {
      if (this.stateLists && this.stateLists.length) {
        this.show = true
      } else {
        this.show = false
      }
    },
  }
}
</script>



<style lang="scss">
.item-headline {
  $e: &;
  font-family: $serif;
  font-weight: 400;
  font-size: 20px;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;

  @include breakpoints-min(md) {
    margin-top: 0;
  }

  &__inner {
    display: inline-block;
    position: relative;
    padding-bottom: 8px;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      border-radius: 99px;
      background: linear-gradient(to right, rgb(255, 186, 115), #ff9c9c);
      width: 100%;
      height: 4px;
    }
  }
}

.app-gogatsu {
    .item-headline {
        $e: &;

        &__inner {
            &::after {
                background: linear-gradient(to right, #8a2ee6, #cfb8e6);
            }
        }
    }
}
</style>
